import URLS from '@/server/urls';
import { POST } from '@/server/http';

export default async ({
    tableId = '',
    setting = {},
    accessToken = '',
}, options = { showError: true }) => {
    const [ content, error, status ] = await POST(URLS.das.utable.saveSetting, {
        tableId,
        setting,
        accessToken,
    }, options);
    if (error) return { error, status };
    return content || {};
};
